<template>
    <div>


        <div class="main-wrapper">

            <sidebar-component classMenu="Dashboard"></sidebar-component>
            <div class="page-wrapper">
                <navbar-component></navbar-component>
                <div class="page-content">
                    <div class="col-lg-12 col-xl-12 stretch-card">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <h4 style="margin-right: 5px" class="float-start">
                                            Master Email Notification
                                        </h4>

                                        <button v-if="permision_role.method_create" type="button" @click="addData"
                                            class="btn-warning btn btn-xs float-end">
                                            <i class="link-icon" data-feather="plus"></i>
                                            Tambah Baru
                                        </button>

                                        <!-- <button v-if="this.permision_role.method_read" class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="downloadData()">
                      <i class="link-icon" data-feather="download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button> -->
                                    </div>


                                </div>
                            </div>
                            <div class="card-body">

                                <vue-good-table title="list-user" mode="remote" @on-page-change="onPageChange"
                                    @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                                    :isLoading.sync="isLoading" :pagination-options="{
                                        enabled: true,
                                    }" :select-options="{
                    enabled: true,
                    selectOnCheckboxOnly: true,
                    selectionText: $t('data_selected'),
                    clearSelectionText: $t('clear'),
                }" @on-selected-rows-change="selectionChanged" :rows="rows" :columns="columns">

                                    <div slot="selected-row-actions">
                                        <!-- <button class="btn btn-success btn-xs" @click="massDownload" style="margin-right:20px;"><i class="mdi mdi-file-document"></i>{{ $t("downloadData") }} .docx  </button>
                    <button class="btn btn-warning btn-xs" v-if="btnKirim" @click="kirimClaim">Kirim Claim</button> -->
                                    </div>

                                    <template slot="table-row" slot-scope="props">
                                        <span v-if="props.column.field == 'actions'">

                                            <span v-if="permision_role.method_create">
                                                <a href="#" title="Edit"
                                                    @click.prevent="editData(props.row)">
                                                    <i class="mdi mdi-square-edit-outline" style="font-size: 16px"></i>
                                                </a>


                                                  <a href="#" title="Delete"
                                                    @click.prevent="deleteData(props.row)">
                                                    <i class="mdi mdi-close" style="font-size: 16px"></i>
                                                </a>

                                            </span>



                                            <!-- <a href="#" title="Detail"
                                                @click.prevent="detailData(props.index, props.row)">
                                                <i class="mdi mdi-eye" style="font-size: 16px"></i>
                                            </a> -->
                                        </span>

                                        <!-- <span v-if="props.column.field == 'selfFlag'">
                         <i class="mdi mdi-check-circle" v-if="props.row.selfFlag=='Y'" style="font-size: 16px"></i>
                         <i class="mdi mdi-close-circle" v-if="props.row.selfFlag=='N'" style="font-size: 16px"></i>
                     </span> -->


                                        <span v-if="flagFields.includes(props.column.field)">
                                            <i class="mdi mdi-check-circle" v-if="props.row[props.column.field] === 'Y'"
                                                style="font-size: 16px; color: green"></i>

                                            <i class="mdi mdi-close-circle" v-else
                                                style="font-size: 16px; color: red"></i>
                                        </span>



                                        <span v-else>
                                            {{ props.formattedRow[props.column.field] }}
                                        </span>
                                    </template>
                                </vue-good-table>
                            </div>


                        </div>
                    </div>
                </div>

                <footer-component></footer-component>
            </div>
        </div>

    </div>
</template>

<script>

import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

import moment from "moment";
// import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import modalCancelFppk from "@/components/modal/modalCancelFppk.vue";

export default {
    name: "FppkPengajuan",
    components: {
        "sidebar-component": sidebarComponent,
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        // DateRangePicker,
        // "modal-cancel-fppk": modalCancelFppk,
    },
    data() {


        // const startDate = moment(Date.now()).format("YYYY-MM-DD");
        // //const startDate = new Date();
        // const endDate = moment(Date.now()).format("YYYY-MM-DD");

        const startDate = moment().subtract(7, 'd').format('YYYY-MM-DD');
        //const startDate = new Date();
        const endDate = moment(Date.now() + 7 * 24 * 3600 * 1000).format('YYYY-MM-DD');

        return {
            flagFields: [
                'selfFlag',
                'jakartaFlag',
                'medanFlag',
                'surabayaFlag',
                'semarangFlag',
                'daily_reportFlagJKT',
                'daily_reportFlagMDN',
                'daily_reportFlagSMG',
                'daily_reportFlagSBY'
            ],
            fppk_id: '',
            showModalCancelFppk: false,
            dataFppk: '',
            btnKirim: false,

            dateRange: {
                startDate: startDate, // 7 days backward from today
                endDate: endDate,
            },


            statusFilter: [
                {
                    text: "SEMUA",
                    value: "SEMUA"
                },
                {
                    text: "BARU",
                    value: "BARU"
                },
                {
                    text: "PENGAJUAN",
                    value: "PENGAJUAN"
                },
                {
                    text: "PENERIMAAN",
                    value: "PENERIMAAN"
                },
                {
                    text: "KOREKSI",
                    value: "KOREKSI"
                },
                {
                    text: "SELESAI",
                    value: "SELESAI"
                },

            ],
            claim_ids: [],
            status: [],
            statusAll: true,
            searchBy: [
                {
                    text: "Route",
                    field: "route"
                },
                {
                    text: "Nopol",
                    field: "nopol"
                },
                {
                    text: "Merk",
                    field: "merk"
                },
                {
                    text: "Jenis Unit",
                    field: "jenis_unit"
                },
                {
                    text: "FPPK No",
                    field: "no_fppk"
                },
                {
                    text: "Status",
                    field: "status"
                },
            ],
            search: [],
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            columns: [
                {
                    label: "Action",
                    field: "actions",
                    width: "100px",
                },
                {
                    label: "Username",
                    field: "username",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },

                },
                {
                    label: "Self",
                    field: "selfFlag",

                },
                {
                    label: "Jakarta",
                    field: "jakartaFlag",
                },
                {
                    label: "Semarang",
                    field: "semarangFlag",

                },
                {
                    label: "Surabaya",
                    field: "surabayaFlag",

                },

                {
                    label: "Medan",
                    field: "medanFlag",

                },

                {
                    label: "Daily Report JKT",
                    field: "daily_reportFlagJKT",

                },


                {
                    label: "Daily Report SMG",
                    field: "daily_reportFlagSMG",

                },

                {
                    label: "Daily Report SBY",
                    field: "daily_reportFlagSBY",

                },

                {
                    label: "Daily Report MDN",
                    field: "daily_reportFlagMDN",

                },





            ],
            rows: [],
            totalRecords: 0,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            permision_role: [],
            langs: ["id", "en"],
            opens: "center",
            locale: {
                format: "yyyy-mm-dd",
            },
        };
    },
    methods: {
     


        checkAll(ev) {
            if (ev == true) {
                this.status = ['Draft', 'Pengajuan', 'Mulai Service', 'Selesai Service', 'Expired', 'Cancelled', 'Reopen']
            } else {
                this.status = []
            }

            // console.log(ev)
        },
        onColumnFilter(params) {
            params.page = 1;
            this.updateParams(params);
        },

        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },


         deleteData(row) {
            console.log(row);
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                var formData = {
                    status: status,
                };
                const baseURI =
                    this.$settings.endPoint + "claim/email-notification/delete/" + row.claim_email_notification_id;
                this.$http
                    .post(baseURI, formData)
                    .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                        this.success(response.data.datas.messages);
                        this.loadItems();
                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                    })
                    .catch((error) => {
                    this.loading();
                    if (error.response) {
                        if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                        } else if (error.response.status === 500) {
                        this.$router.push("/server-error");
                        } else {
                        this.$router.push("/page-not-found");
                        }
                    }
                    });
                }
            });
            },

        submitToCt(row) {

            this.fade(true);
            const baseURI = this.$settings.endPointCt + "master-truck/update-truck-status-for-fppk";
            this.$http
                .post(baseURI, row)
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                        // this.updateStatus(row.fppk_id, 'Pengajuan')

                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            if (this.errors.message) {
                                this.error(this.errors.message);
                            } else {
                                this.resultError(error.response.data.errors);
                            }
                        } else if (error.response.status === 500) {
                            this.error(error.response.data.errors.message);
                        } else {
                            this.$router.push("/page-not-found");
                        }
                    }
                    //this.resetForm();
                });
        },

          formatLabel(field) {
                // ubah snakeCase / camelCase jadi label rapi
                return field
                .replace(/([A-Z])/g, " $1")        // pisah huruf besar
                .replace(/_/g, " ")                // ganti _ dengan spasi
                .replace(/\s+/g, " ")              // rapihkan spasi ganda
                .trim()
                .replace(/^./, (c) => c.toUpperCase()); // huruf awal kapital
            },

        selectionChanged(ev) {
            this.rowsSelection = [];
            this.rowsSelection = ev.selectedRows;
            this.claim_ids = [];
            this.rowsSelection.forEach((item) => {
                this.claim_ids.push(item.claim_id);
                if (item.claim_status == 'PENGAJUAN' || item.claim_status == 'SELESAI' || item.claim_status == 'KOREKSI') {
                    this.btnKirim = true;
                } else {
                    this.btnKirim = false;
                }


            });
            console.log(this.claim_ids);
        },

        async addData() {
  let html = `
   <div style="text-align:left">
    <div class="form-group mb-3">
      <label><b>Username</b></label>
      <input id="swal-username" class="form-control" placeholder="Username">
    </div>
    
    <hr>
    <div class="row">
  `;

  this.flagFields.forEach((field, index) => {
    // buka row baru tiap 2 field
    if (index % 2 === 0 && index !== 0) {
      html += `</div><div class="row">`;
    }

    html += `
      <div class="col-md-6 mb-3">
        <label><b>${this.formatLabel(field)}</b></label><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="${field}" value="Y" checked>
          <label class="form-check-label">Yes</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="${field}" value="N">
          <label class="form-check-label">No</label>
        </div>
      </div>
    `;
  });

  html += `</div></div>`; // tutup row dan wrapper

  const { value: form } = await this.$swal({
    title: "Tambah Data",
    html: html,
    width: 800,
    focusConfirm: false,
    preConfirm: () => {
      const data = {
        username: document.getElementById("swal-username").value,
       
      };
      this.flagFields.forEach((field) => {
        data[field] = document.querySelector(`input[name="${field}"]:checked`).value;
      });
  
       const baseURI = this.$settings.endPoint +
            "claim/email-notification/create";

          // return promise biar swal tunggu
          return this.$http.post(baseURI, data, { timeout: 200000 })
            .then((response) => {
              if (response.data.status === 200) {
                console.log(response.data.meta.datas);

                //let msg = response.data.meta.datas;
                let pesan = "Succes";
               

                this.$swal({
                  icon: 'info',
                  backdrop: true,
                  title: "Information",
                  html: pesan,
                  showConfirmButton: true,
                  allowOutsideClick: false,
                  allowEscapeKey: false
                })

               
                return true; // Swal close otomatis
              } else {
                // tampilkan error di dalam Swal tanpa close
                this.$swal.showValidationMessage(
                  `Error: ${response.data.errors?.validation_request[0] || 'Gagal update'}`
                );
                return false;
              }
            })
            .catch(error => {
              console.log(error)
              let msg = "Unexpected error";
              if (error.code == "ECONNABORTED") {
                msg = this.$t("check_internet_connection_txt");
                this.$swal.showValidationMessage(`Request failed: ${msg}`);
              } else if (error.response?.status === 422) {
                msg = "";
               
                msg = JSON.stringify(error.response.data.errors.validation_request);
                this.$swal.showValidationMessage(`Request failed: ${msg}`);

              } else if (error.response?.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response?.status === 401) {
                this.$router.push('/authorized-error');
              } else if (error.response?.status === 404) {
                this.$router.push('/page-not-found');
              }

            });
    },
    showCancelButton: true,
    confirmButtonText: "Simpan",
  });

  if (form) {
    // this.rows.push({
    //   id: this.rows.length + 1,
    //   ...form,
    // });
     this.loadItems();
    // console.log(this.rows);
    this.$swal("Berhasil!", "Data berhasil ditambahkan", "success");
  }
},

// EDIT
async editData(row) {
  let html = `
    <div style="text-align:left">
      <div class="form-group mb-3">
       
        <label><b>Username</b></label>
      <input id="swal-username" class="form-control" placeholder="Username" value="${row.username || ''}">
      </div>
     
      <hr>
      <div class="row">
  `;

  this.flagFields.forEach((field, index) => {
    if (index % 2 === 0 && index !== 0) {
      html += `</div><div class="row">`;
    }

    html += `
      <div class="col-md-6 mb-3">
        <label><b>${this.formatLabel(field)}</b></label><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="${field}" value="Y" ${row[field] === "Y" ? "checked" : ""}>
          <label class="form-check-label">Yes</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="${field}" value="N" ${row[field] === "N" ? "checked" : ""}>
          <label class="form-check-label">No</label>
        </div>
      </div>
    `;
  });

  html += `</div></div>`; // tutup row dan wrapper

  const { value: form } = await this.$swal({
    title: "Edit Data",
    html: html,
    width: 800,
    focusConfirm: false,
    preConfirm: () => {
      const data = {
        username: document.getElementById("swal-username").value,
      
      };
      this.flagFields.forEach((field) => {
        data[field] = document.querySelector(`input[name="${field}"]:checked`).value;
      });
      
      const baseURI = this.$settings.endPoint +
            "claim/email-notification/update/"+row.claim_email_notification_id;

          // return promise biar swal tunggu
          return this.$http.post(baseURI, data, { timeout: 200000 })
            .then((response) => {
              if (response.data.status === 200) {
                console.log(response.data.meta.datas);

                //let msg = response.data.meta.datas;
                let pesan = "Succes";
               

                this.$swal({
                  icon: 'info',
                  backdrop: true,
                  title: "Information",
                  html: pesan,
                  showConfirmButton: true,
                  allowOutsideClick: false,
                  allowEscapeKey: false
                })

               
                return true; // Swal close otomatis
              } else {
                // tampilkan error di dalam Swal tanpa close
                this.$swal.showValidationMessage(
                  `Error: ${response.data.errors?.validation_request[0] || 'Gagal update'}`
                );
                return false;
              }
            })
            .catch(error => {
              console.log(error)
              let msg = "Unexpected error";
              if (error.code == "ECONNABORTED") {
                msg = this.$t("check_internet_connection_txt");
                this.$swal.showValidationMessage(`Request failed: ${msg}`);
              } else if (error.response?.status === 422) {
                msg = "";
               
                msg = JSON.stringify(error.response.data.errors.validation_request);
                this.$swal.showValidationMessage(`Request failed: ${msg}`);

              } else if (error.response?.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response?.status === 401) {
                this.$router.push('/authorized-error');
              } else if (error.response?.status === 404) {
                this.$router.push('/page-not-found');
              }

            });

    },
    showCancelButton: true,
    confirmButtonText: "Update",
  });

  if (form) {
    this.loadItems();
    this.$swal("Berhasil!", "Data berhasil diperbarui", "success");
  }
},


        kirimClaim() {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataSend"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    // this.loadingSubmiting();
                    this.fade(true);
                    let data = {
                        "claim_status": "SELESAI", // in:PENGAJUAN,SELESAI,KOREKSI
                        "claim_ids": this.claim_ids
                    }
                    const baseURI =
                        this.$settings.endPoint + "claim/update-claim-status";
                    this.$http
                        .post(baseURI, data, { timeout: 30000 })
                        .then((response) => {
                            // this.loading();
                            if (response.data.status === 200) {

                                if (response.data?.errors?.messages?.length) {
                                    const errorMessages = response.data.errors.messages
                                        .map(msg => `<li>${msg}</li>`)
                                        .join('');

                                    this.$swal.fire({
                                        icon: "info", // bisa juga 'warning' kalau lebih pas
                                        title: "Informasi",
                                        html: `<ul style="text-align:left; padding-left:15px;">${errorMessages}</ul>`,
                                        confirmButtonText: "OK",
                                    });
                                } else {
                                    // kalau memang berhasil tanpa error
                                    this.$swal.fire({
                                        icon: "success",
                                        title: "Success",
                                        text: "Data berhasil diproses",
                                        confirmButtonText: "OK",
                                    });
                                }

                                this.loadItems();
                                this.isloading = false;
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        }).catch(error => {
                            this.isLoading = false;
                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));
                            } else {

                                if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 500) {
                                        this.$router.push('/server-error');
                                    } else if (error.response.status === 401) {
                                        this.$router.push("/authorized-error");
                                    } else {
                                        this.$router.push('/page-not-found');
                                    }
                                }

                            }

                        });
                }
            });
        },

        updateStatus(row, status) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: 'Update Status to: ' + status,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    if (status == 'Pengajuan') {

                        var keluhanArray = [
                            row.keluhan1,
                            row.keluhan2,
                            row.keluhan3,
                            row.keluhan4,
                            row.keluhan5,
                            row.keluhan6
                        ].filter(keluhan => keluhan !== undefined && keluhan !== null);


                        var dataSendCT = {

                            "vehicle_no": row.nopol,
                            "status_time": moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                            "master_status_id": 8,
                            "reference": row.no_fppk,
                            "status_type": 'Pengajuan',
                            "estimation_date": row.tgl_estimasi_tiba,
                            "fppk_keluhan": keluhanArray.join(';')
                        };
                        this.submitToCt(dataSendCT);
                    }

                    const baseURI = this.$settings.endPoint + "claim/pengajuan";
                    this.$http
                        .post(baseURI, {
                            status: status
                        })
                        .then((response) => {
                            this.isLoading = false;
                            if (response.data.status === 200) {

                                this.loadItems()
                                this.success("Success");

                            } else {

                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }


                        })
                        .catch((error) => {

                            if (error.response) {
                                if (error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);

                                }
                            }
                            this.isloading = false;
                        });
                }

            })


        },

        resetBtn() {
            // this.dateRange= {
            //   startDate:null,
            //   endDate:null
            // };
            this.search.text = '';
            this.search.filterBy = '';
            this.status = [];
            this.loadItems();
        },



        downloadData() {
            this.fade(true);

            let data = {};

            // jika ada status, simpan ke data
            if (this.status.length > 0) {
                data["statusArray"] = this.status;
            }

            // jika ada date range
            if (this.dateRange.startDate || this.dateRange.endDate) {
                data['claim_date'] =
                    moment(this.dateRange.startDate).format("YYYY-MM-DD") +
                    '~' +
                    moment(this.dateRange.endDate).format("YYYY-MM-DD");
            }

            // filter text
            data[this.search.filterBy] = this.search.text;

            const baseURI = this.$settings.endPoint + "claim/pengajuan";
            var file_name = `pengajuan_claim_` + data.claim_date + `.xlsx`;
            // buat query statusArray
            let statusQuery = '';
            if (data.statusArray && data.statusArray.length > 0) {
                statusQuery = data.statusArray
                    .map(item => `&statusArray[]=${encodeURIComponent(item)}`)
                    .join('');
            }

            return this.$http
                .get(
                    `${baseURI}?jenis=${this.serverParams.columnFilters.jenis}&order_no=${this.serverParams.columnFilters.order_no}&customer=${this.serverParams.columnFilters.customer_name}&pick_plan=${this.serverParams.columnFilters.pick_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&drop_plan=${this.serverParams.columnFilters.drop_plan}&drop_name=${this.serverParams.columnFilters.drop_name}&nopol=${this.serverParams.columnFilters.vehicle_no}&nmk_driver=${this.serverParams.columnFilters.driver_nmk}&nama_driver=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&cabang=${this.serverParams.columnFilters.branch}&status=${this.serverParams.columnFilters.claim_status}&aging=${this.serverParams.columnFilters.aging}&claim_date=${data.claim_date || ''}${statusQuery}&download=download`
                    , { responseType: "blob" })
                .then((response) => {

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);

                });
        },



        massDownload() {
            this.fade(true);

            const baseURI = this.$settings.endPoint + "claim/mass-download-docx";
            //var file_name = `mass_pengajuan_claim_` + data.claim_date + `.docx`;
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "mass_pengajuan_claim_" + CurrentDate + ".docx";
            // buat query statusArray

            return this.$http
                .post(
                    `${baseURI}`
                    , {
                        "claim_ids": this.claim_ids
                    }, { responseType: "blob" })
                .then((response) => {

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);

                });
        },

        searchFunction() {
            this.row = [];
            var data = {};

            if (this.status.length > 0) {
                data["statusArray"] = this.status;
            }

            // var data={
            //     "status_fppks" : dataStatus
            // }

            if (this.dateRange.startDate != undefined || this.dateRange.endDate != undefined) {
                data['claim_date'] = moment(this.dateRange.startDate).format("YYYY-MM-DD") + '~' + moment(this.dateRange.endDate).format("YYYY-MM-DD")
            }

            data[this.search.filterBy] = this.search.text
            // console.log(data);

            this.fade(true);
            const baseURI = this.$settings.endPoint + "claim/pengajuan";

            return this.$http
                .post(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page
                    }&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type
                    }
          `, data
                )
                .then((response) => {
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                    this.loading();
                }).catch((error) => {
                    this.loading();
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            if (this.errors.message) {
                                this.error(this.errors.message);
                            } else {
                                this.resultError(error.response.data.errors);
                            }
                        } else if (error.response.status === 500) {
                            this.error(error.response.data.errors.message);
                        } else {
                            this.$router.push("/page-not-found");
                        }
                    }
                    //this.resetForm();
                });

        },


        detailData(index, row) {
            var params = this.$onRandom(row.claim_id);
            window.location.href = "/claim/penerimaan/detail/" + params;

        },

        // editData(index, row) {
        //     var params = this.$onRandom(row.claim_id);
        //     window.location.href = "/claim/penerimaan/edit/" + params;
        // },

        editDataRevisi(index, row) {
            var params = this.$onRandom(row.fppk_id);
            window.location.href = "/fppk-pengajuan/edit/" + params + "?revisi=true";
        },

        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },

        closeMyModal() {
            this.showModalCancelFppk = false;
            this.loadItems();
        },

        loadItems() {
            this.fade(true);

            const baseURI = this.$settings.endPoint + "claim/email-notification";

            return this.$http
                .get(
                    `${baseURI}?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&username=${this.serverParams.columnFilters.username}`
                )
                .then((response) => {
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                    this.loading();
                });
        },


        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == "ClaimEmailNotificationController") {
                    rolePermision = permision;
                    // console.log(permision);
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        btnModalShowCancel(row) {
            this.fppk_id = row.fppk_id
            this.dataFppk = row
            this.showModalCancelFppk = true
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },
    },

    mounted() {
        this.loadItems();
        this.fetchIt();
        this.loading();
    },
};
</script>

<style></style>